import * as React from "react";

const StockStatus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="currentColor">
            <path
                fill="#00205B"
                d="M11.25 1.5a.747.747 0 0 1-.22.53l-6 6a.746.746 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06L4.5 6.44 9.97.97a.75.75 0 0 1 1.28.53Z"
            />
        </svg>
    );
};

export default React.memo(StockStatus);
